<template>
  <button
    class="btn"
    @click="$emit('click', $event)"
    :disabled="loading"
    :style="btnStyle"
  >
    <slot v-if="!loading"></slot>
    <pulse-loader
      :size="loadingSize + 'px'"
      v-if="loading"
      :color="loadingColor"
    />
  </button>
</template>

<script>
export default {
  name: "button-loading",
  props: {
    loading: Boolean,
    loadingColor: String,
    loadingSize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    btnStyle: function () {
      if (this.loading) {
        return { background: "transparent", cursor: "default" };
      }
      return {};
    },
  },
};
</script>
